import * as Sentry from '@sentry/browser';
import configuration from '../configuration';
import {CaptureConsole, HttpClient} from '@sentry/integrations';


class SentryService {
    initialize() {
        Sentry.init({
            dsn: 'https://e403493ffe8c38dc23a3a2730bdc1771@o4511449410437120.ingest.de.sentry.io/4511449411682384',
            environment: configuration.environment,
            maxBreadcrumbs: 20,
            integrations: [
                new Sentry.BrowserTracing({
                    tracePropagationTargets: [window.location.origin],
                }),
                new Sentry.Replay({
                    networkDetailAllowUrls: [
                        window.location.origin,
                        configuration.baseURL,
                    ],
                    networkRequestHeaders: ['Cache-Control'],
                    networkResponseHeaders: ['Referrer-Policy'],
                }),
                new CaptureConsole({
                    levels: ['error'],
                }),
                new HttpClient({
                    failedRequestStatusCodes: [
                        [500, 599],
                        [400, 499],
                    ],
                    failedRequestTargets: [/.*/],
                }),
            ],
            sendDefaultPii: true,
            tracesSampleRate: configuration.environment === 'Development' ? 0 : 0.01, // Capture 100% of the transactions, reduce in production!
            // Session Replay
            replaysSessionSampleRate: 0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
            replaysOnErrorSampleRate: 0.1, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
        });
    }

    setUser({userId, email} : {userId?: string; email?: string}) {
        Sentry.setUser({ id: userId, email });
    }

    clearUser() {
        Sentry.setUser(null);
    }

    setAppointmentContext(context : Record<string, any>) {
        Sentry.setContext('Appointment', context);
    }

    setTag(key: string, value: string) {
        Sentry.setTag(key, value);
    }

    captureException(error: Error, extra?: Record<string, any>) {
        Sentry.captureException(error);
    }

    captureReferralException(appointmentId: string, data: any) {
        Sentry.withScope((scope) => {
        scope.setTag("feature", "referral");
        scope.setTag("appointmentId", appointmentId);

        scope.setContext("referral", {
            appointmentId: appointmentId,
            response: data,
        });

        Sentry.captureException(
            new Error("Error issuing referral")
        );
        });
    }

    capturePrescriptionException(appointmentId: string, data: any) {
        Sentry.withScope((scope) => {
        scope.setTag("feature", "prescription");
        scope.setTag("appointmentId", appointmentId);

        scope.setContext("prescription", {
            appointmentId: appointmentId,
            response: data,
        });

        Sentry.captureException(
            new Error("Error issuing prescription")
        );
        });

    }

}

export default new SentryService();
